import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";
import PropTypes from "prop-types";
import { memo } from "react";

// Simple spinning loader component
const SpinningGradientLoader = memo(({ size = "default" }) => {
  const sizes = {
    small: "h-8 w-8",
    default: "h-12 w-12",
    large: "h-16 w-16",
  };

  return (
    <Loader2
      className={cn(
        sizes[size],
        "animate-spin text-purple-600 dark:text-purple-400"
      )}
    />
  );
});

SpinningGradientLoader.displayName = "SpinningGradientLoader";

export const PageLoader = memo(function PageLoader({
  className,
  size = "default",
}) {
  return (
    <div
      className={cn(
        "fixed inset-0 z-50",
        "flex flex-col items-center justify-center",
        "bg-background/80 backdrop-blur-sm",
        "animate-fadeIn",
        className
      )}
      role="alert"
      aria-live="polite"
    >
      <SpinningGradientLoader size={size} />
    </div>
  );
});

PageLoader.displayName = "PageLoader";

PageLoader.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(["small", "default", "large"]),
};

SpinningGradientLoader.propTypes = {
  size: PropTypes.oneOf(["small", "default", "large"]),
};

export default PageLoader;
